import React from 'react';
import Translate from "../../../components/Translate";
import LoadingSpinner from "../../../components/LoadingSpinner";
import Pagination from "../../../components/Pagination";

const ResourcesTable = ({
                            isLoading,
                            rows,
                            currentUser,
                            currentPage,
                            pageNumbers,
                            handleNextPage,
                            handlePageClick,
                            handlePreviousPage,
                            handleRowsPerPageChange,
                            rowsPerPage,
                            totalPages,
                            filteredResources,
                        }) => (
    <div className="project-keys">
        {isLoading ? (
            <LoadingSpinner />
        ) : (
            <>
                <table className="keys-table">
                    <thead>
                    <tr>
                        <th><Translate language={currentUser.language} text={'keyName'}/></th>
                        <th><Translate language={currentUser.language} text={'description'}/></th>
                        <th><Translate language={currentUser.language} text={'value'}/></th>
                        <th><Translate language={currentUser.language} text={'type'}/></th>
                        <th><Translate language={currentUser.language} text={'actions'}/></th>
                    </tr>
                    </thead>
                    <tbody>{rows}</tbody>
                </table>
                <Pagination
                    currentPage={currentPage}
                    pageNumbers={pageNumbers}
                    handleNextPage={handleNextPage}
                    handlePageClick={handlePageClick}
                    handlePreviousPage={handlePreviousPage}
                    handleRowsPerPageChange={handleRowsPerPageChange}
                    rowsPerPage={rowsPerPage}
                    totalPages={totalPages}
                    totalResources={filteredResources.length}
                />
            </>
        )}
    </div>
);

export default ResourcesTable;
